module.exports = __webpack_public_path__ + "static/media/Lightyear.6a868164.svg";